// eslint-disable-next-line no-restricted-imports
import { useQuery } from "@tanstack/react-query";
import { feedKeys } from "src/api/client/feed/feed.query-keys";
import { IFeedCard } from "src/components/feed-card/types/feed-card";

export const getInitialPinnedCommentId = (feed: IFeedCard[]): string | null => feed.find(card => Boolean(card.footer?.pinInfo?.isPinned))?.id ?? null;

interface IUsePinnedCommentIdParams {
    wikifolioId: string;
    feed: IFeedCard[] | null;
}

export const usePinnedCommentId = ({ wikifolioId, feed }: IUsePinnedCommentIdParams): string | null => {
    const hasFeed = Array.isArray(feed);

    const { data: pinnedCommentId = null } = useQuery<string | null>({
        // The query only derives its seed from the feed once; the live value is owned by the cache and updated via setQueryData,
        // so the feed must not be part of the queryKey.
        // eslint-disable-next-line @tanstack/query/exhaustive-deps
        queryKey: feedKeys.pinnedComment(wikifolioId),
        queryFn: () => getInitialPinnedCommentId(feed ?? []),
        enabled: hasFeed,
        initialData: hasFeed ? getInitialPinnedCommentId(feed) : undefined,
        staleTime: Infinity,
        gcTime: Infinity,
    });

    return pinnedCommentId;
};
